(function () {
  const MQ = window.matchMedia("(max-width: 749px)");

  function init() {
    if (!MQ.matches) return;

    document.querySelectorAll(".tf-footer").forEach((footer) => {
      const menus = footer.querySelector(".tf-footer__menus");
      if (!menus) return;

      menus.querySelectorAll(".tf-footer__col").forEach((col) => {
        // already converted
        if (col.classList.contains("tf-footer-acc")) return;

        const heading = col.querySelector(".tf-footer__heading");
        const list = col.querySelector(".tf-footer__list");

        if (!heading || !list) return;

        const title = (heading.textContent || "").trim();
        if (!title) return;

        col.classList.add("tf-footer-acc");

        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "tf-footer-acc__btn";
        btn.setAttribute("aria-expanded", "false");
        btn.innerHTML = `
          <span class="tf-footer-acc__title">${title}</span>
          <span class="tf-footer-acc__icon" aria-hidden="true"></span>
        `;

        const panel = document.createElement("div");
        panel.className = "tf-footer-acc__panel";
        panel.style.maxHeight = "0px";

        // move list into panel
        panel.appendChild(list);

        // replace heading with button
        heading.replaceWith(btn);
        btn.insertAdjacentElement("afterend", panel);

        btn.addEventListener("click", () => {
          const isOpen = col.classList.toggle("is-open");
          btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
          panel.style.maxHeight = isOpen ? panel.scrollHeight + "px" : "0px";
        });
      });
    });
  }

  function refresh() {
    if (!MQ.matches) return;
    document.querySelectorAll(".tf-footer-acc.is-open .tf-footer-acc__panel").forEach((panel) => {
      panel.style.maxHeight = panel.scrollHeight + "px";
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  window.addEventListener("resize", () => {
    clearTimeout(window.__tfFooterAccT);
    window.__tfFooterAccT = setTimeout(() => {
      init();
      refresh();
    }, 200);
  });
})();
